export const UFClinicsToExclude = [
  'ckg9vu23tl7c4071287j3bmed', //Real Baxter Sunshine Clinic - Testing Dev
  'clduw2ipy001401p6z2t29whv', //Test Veterinary Hospital - run 1 - Dev
  'cljhfxs3m0050yb01xsi86oqv', //University of Florida Veterinary Hospital - Gainesville - Prod
  'cljhfw67p001k0y01qou5djms', //UF at WEC - Veterinary Hospital, Ocala - Prod
  'cljhg0hn503g61p01enya6e9w', //UF Pet Emergency Treatment Services, Ocala - Prod
];
